class PromoteClass extends HTMLElement {
  constructor() {
    super();
    this.sliderWrapper = this.querySelector(".promote-class__slider .swiper");
    this.nextButton = this.sliderWrapper.querySelector(".swiper-button-next");
    this.prevButton = this.sliderWrapper.querySelector(".swiper-button-prev");
  }
  connectedCallback() {
    if (this.sliderWrapper) {
      this.initializeSliders();
    }
  }

  initializeSliders() {
    new Swiper(this.sliderWrapper, {
      slidesPerView: "auto",
      spaceBetween: 24,
      autoHeight: true,
      navigation: {
        nextEl: this.nextButton,
        prevEl: this.prevButton,
      },
      breakpoints: {
        769: {
          // rewind: true,
          spaceBetween: 16,
        },
      },
    });
  }
}

customElements.define("promote-class", PromoteClass);
